import React from 'react';
import { merge } from 'lodash';
import randomcolor from 'randomcolor';
import VisualisationsToolboxAbstract from '../VisualisationsToolboxAbstract';
import Circumplex from '../../components/analysis/visualisations/Circumplex';

class CircumplexToolbox extends VisualisationsToolboxAbstract {
  static addParams(unit) {
    return {
      id: unit.file,
      ct: 'csv'
    };
  }

  static canProcess(nextProps) {
    return true;
  }

  static getVisualisationComponent(props) {
    if (!props.circumplex) {
      throw new TypeError('Missing circumplex prop');
    }
    const circumplexData = CircumplexToolbox.getUISpecificCircumplexData(props.circumplex);
    return <Circumplex key={0} circumplex={circumplexData} />;
  }

  static getProcessButtonLabel() {
    return 'Process the Circumplex';
  }

  static getBlockParameters() {
    return {
      windowdStep: 1,
      windowdSize: 2,
      extract: true
    };
  }

  static getUISpecificCircumplexData(circumplex) {
    if (!circumplex.canItBeRender) return circumplex;

    // create a copy
    const output = merge({}, circumplex);

    const { data } = output;
    const angularCoefficient = (minX, maxX, minY, maxY) => {
      // y = mx+b
      // https://en.wikipedia.org/wiki/Slope
      const m = (maxY - minY) / (maxX - minX);
      return value => {
        const x = value - minX;
        const b = minX;
        const result = m * x + b;

        return result;
      };
    };

    // const sizeRadiusMinMax = { min: 0.3, max: 17 };

    const radiusAngularCoefficientCalculator = angularCoefficient(
      output.minSize,
      output.maxSize,
      output.minSizeRadius,
      output.maxSizeRadius
    );

    const colorGenerator = (() => {
      const colors = randomcolor({ count: data.length });

      let index = 0;
      return () => {
        index += 1;
        return colors[index - 1];
      };
    })();

    // UI specific data
    data.forEach(d => {
      d.radius = radiusAngularCoefficientCalculator(d.size);
      d.color = colorGenerator();
    });

    return output;
  }
}

export default CircumplexToolbox;



// WEBPACK FOOTER //
// ./src/scenes/analysis/lib/visualisationTypes/CircumplexToolbox.js